import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const WITHOUT = ['Spend hours preparing lessons', 'Constantly search for new activities', 'Keep resources scattered across different folders', "Reuse the same materials because you're short on time", 'Build every lesson from scratch', 'Manually organize student progression', 'Create separate tracking and assessment tools'];
const WITH = ['Prepare your next lessons faster', 'Access structured activities and teaching resources', 'Keep your materials inside one organized system', 'Build lessons more efficiently', 'Adapt resources to different levels and goals', 'Track progress with structured tools', 'Start every lesson with a clear direction'];
export function Comparison() {
  return <section aria-labelledby="comparison-title" className="w-full bg-night px-4 py-8" data-id="element-36" data-mp="28wgjqfabxaea">
      <div className="mx-auto max-w-3xl" data-id="element-37" data-mp="9l5w8gz7sfrf">
        <h2 id="comparison-title" className="text-center font-head text-lg font-bold uppercase leading-[0.98] text-white sm:text-2xl" data-id="element-38" data-mp="eiz37c8cddsr">
          Your next Spanish lesson can still start with a blank page...
          <span className="mt-0.5 block text-cta" data-id="element-39" data-mp="1ha0iap1t26cp">
            Or you can start with a professional system that’s already organized.
          </span>
        </h2>

        <div className="mt-3 grid gap-2 md:grid-cols-2" data-id="element-40" data-mp="1d8nf6mq3kh9h">
          <div className="rounded-xl border border-coral/30 bg-coral/10 p-3" data-id="element-41" data-mp="18a3ragry0veh">
            <h3 className="font-head text-xs font-bold uppercase tracking-wide text-coral sm:text-sm" data-id="element-42" data-mp="24zbedt87ncki">
              Without Spanish Teacher Pro™
            </h3>
            <ul className="mt-1.5 space-y-1" data-id="element-43" data-mp="20yrewj05zwv7">
              {WITHOUT.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] leading-snug text-silver" data-id="element-44" data-mp="1vxu1sku0ht0k">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-coral" aria-hidden="true" data-id="element-45" data-mp="1qz0kehblthv4" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-cta/30 bg-cta/10 p-3" data-id="element-46" data-mp="fk3ruxg7oaj0">
            <h3 className="font-head text-xs font-bold uppercase tracking-wide text-cta sm:text-sm" data-id="element-47" data-mp="h1spzwhcr1ha">
              With Spanish Teacher Pro™
            </h3>
            <ul className="mt-1.5 space-y-1" data-id="element-48" data-mp="m0dgv5aps8t2">
              {WITH.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] leading-snug text-silver" data-id="element-49" data-mp="81nmvyj6yp8x">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-cta" aria-hidden="true" data-id="element-50" data-mp="czfm7dm61dn5" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}